import React from 'react';
import MarketingSection from 'src/components/MarketingSection';
import IntroductionWithMedia from '../IntroductionWithMedia';
import styles from './styles.module.scss';
import { useTranslation, Trans } from 'next-i18next';

interface Props {
    onClick: () => void;
}

const IntroductionSection = (props: Props) => {
    const { t } = useTranslation();

    return (
        <MarketingSection containerClassName={styles.introductionSection} className={styles.inner} isLarge>
            <IntroductionWithMedia
                type="header"
                imgUrl="/static/images/platformFeatures/img_portal@2x.jpg"
                title={t('altive_platform_title')}
                description={<Trans i18nKey="altive_platform_description" />}
                onClick={props.onClick}
                buttonText={t('view_platform_features_button')}
            />
        </MarketingSection>
    );
};

export default IntroductionSection;
